import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-indicator-component',
  templateUrl: './circleIndicator.component.html',
  styleUrls: ['./circleIndicator.component.scss'],
})
export class CircleIndicatorComponent {
  @Input() percentage;
  @Input() title;
  @Input() date;
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/views/dashboardView/CircleIndicatorComponent/circleIndicator.component.ts